import { render, staticRenderFns } from "./addsubRecordCollectTable.vue?vue&type=template&id=1768a1fb&"
import script from "./addsubRecordCollectTable.vue?vue&type=script&lang=js&"
export * from "./addsubRecordCollectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports